
// Button.js

import React from 'react';

import '../../styles/buttons/Button.css';

const Button = ({ onClick, children, type='dark', disabled, size, className = '', loading = false }) => {
    // Dynamically set the button size class
    const sizeClass = size ? `button-size-${size}` : '';

    return (
        <div className='button-container'>
            <button
                className={`button ${type} ${sizeClass} ${loading ? 'button--loading' : ''} ${className}`}
                onClick={onClick}
                disabled={disabled || loading}
                aria-busy={loading}
            >
                {loading && <span className="button-spinner" aria-hidden="true"></span>}
                {children}
            </button>
        </div>
    );
};



export default Button;
